import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 128 68"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#9AA4AB",
      d: "M0 0h128v68H0z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#D0D7D9",
      d: "M0 0h16.067l29.945 34-29.945 34H0l30.1-34zM64 0h16.067l29.945 34-29.945 34H64l30.1-34z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#D0D7D9",
      d: "m56.874 10 21.138 24-21.138 24H40.853l21.248-24-21.248-24zM120.874 10l7.125 8.089v31.82L120.874 58h-16.021l21.248-24-21.248-24zM0 18.09 14.012 34 0 49.908z"
    }, null, -1)
  ]))]))
}
export default { render: render }